// Mirrors the $mobileWidth breakpoint in `styles/mixins/breakpoints.scss` so JS-side
// layout gating and CSS `@include mobileAndBelow` fire at the same cutoff.
export const MOBILE_MAX_WIDTH_PX = 768;

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH_PX}px)`;
